import { FormikErrors, FormikTouched } from 'formik';
import { get } from 'lodash';

export const isRequiredFunc = (field: string) => `${field} is required`;

export const isUrlFunc = (field: string) => `${field} should be valid url`;

export const isEmailFunc = (field: string) => `${field} should be valid email`;

export const isMinFunc = (field: string, numberOfCharacter: number) =>
  `${field} should be more than ${numberOfCharacter} characters`;

export const isMaxFunc = (field: string, numberOfCharacter: number) =>
  `${field} should not be greater than ${numberOfCharacter} characters`;

export const urlRegMatch =
  // eslint-disable-next-line max-len
  /^((http|https):\/\/)?(www.)?(?!.*(http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+(\/)?.([\w\?[a-zA-Z-_%\/@?]+)*([^\/\w\?[a-zA-Z0-9_-]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/;

export const passwordRegMatch =
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/gm;

export const isPasswordRegFunc = (field: string) =>
  `${field} must contain 8 characters, one uppercase letter, special character and number`;

export const isNumberFunc = (field: string) => `${field} must be a number`;

export const rwPhoneRegex = /^2507[2389]\d{7}$/;
export const formatPhone = (phoneNumber?: string) => {
  let phone = phoneNumber
    ?.trim()
    .replace(/ /g, '')
    .replace(/-/g, '')
    .replace(/\+/g, '');

  if (!phone?.startsWith('250')) {
    if (phone?.startsWith('+250')) {
      phone = phone.replace('+250', '250');
    }

    if (phone?.startsWith('7')) {
      phone = '250' + phone;
    }

    if (phone?.startsWith('0')) {
      phone = '25' + phone;
    }
  }
  return phone;
};

export const showFormError = <T>(
  errors?: FormikErrors<T>,
  touched?: FormikTouched<T> | undefined | null,
  key?: keyof T,
) => {
  if (!errors || !touched || !key) {
    return undefined;
  }
  const hasError = get(errors, key);
  const isTouched = touched ? get(touched, key) : true;

  if (hasError && isTouched) {
    return get(errors, key)?.toString();
  }
  return undefined;
};
